import { getFilter } from 'data/filters';
import { Aggregations } from 'model/SearchResults';
import React from 'react';
import { areThereResults } from 'utils/searchResults';

import Checkbox from '../Checkbox';

const CSS = require('./LanguagesList.module.scss');

const LANGUAGES = getFilter('languages.items[]').subOptions.map(
  ({ name, value, id }) => ({ name, value, id }),
);

interface LanguagesListProps {
  selectedLanguages: number[];
  onLanguageClick: (
    value: string,
  ) => (event: React.ChangeEvent<HTMLInputElement>) => void;
  aggregations: Aggregations;
}

function LanguagesList({
  selectedLanguages,
  onLanguageClick,
  aggregations,
}: LanguagesListProps) {
  return (
    <ul>
      {LANGUAGES.filter((lang) => {
        const res = areThereResults(
          aggregations?.global?.location_filtered,
          'languages.items[]',
          decodeURIComponent(lang.value),
          false,
          null,
        );
        return res;
      }).map(({ name, value, id }) => {
        const isSelected = selectedLanguages.some((lang) => lang === id);
        return (
          <li key={name} className={CSS.ListItem}>
            <Checkbox
              value={id}
              onChange={onLanguageClick(value)}
              checked={isSelected}
            >
              {name}
            </Checkbox>
          </li>
        );
      })}
    </ul>
  );
}

export default LanguagesList;
